<template>
    <section class="content">
        <div class="container-fluid">
            <div class="block-header">
                <h2>Notifikasi</h2>
            </div>
            <div class="row clearfix">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="card">
                        <div class="header">
                            <h2>
                                Kirim Notifikasi
                            </h2>
                        </div>
                        <div class="body">
                            <form class="form-horizontal" @submit.prevent="kirim">
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="subjek">Pesan</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <form-line id="subjek" type="text" v-model="send.message"></form-line>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                        <button v-bind:disabled="isLoading" type="submit" class="btn btn-primary waves-effect waves-button" v-waves.button>
                                            <span v-if="!isLoading"><i class="material-icons">save</i> Kirim</span>
                                            <span v-else><i class="fa fa-spinner fa-spin"></i> Loading</span>
                                        </button>
                                        <button v-bind:disabled="isLoading" @click="$router.go(-1)" type="button" class="btn btn-danger" v-waves.button><i class="material-icons">cancel</i> Batal</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
  import FormLine from '@/components/FormLine.vue'
  import api from '@/helper/api'

  export default {
    components: {FormLine},
    name: 'Notifikasi',
    data: function () {
      return {
        send: {
          tipe: 13,
          message: ''
        },
        isLoading: false
      }
    },
    methods: {
      kirim () {
        this.isLoading = true
        var form = new FormData()
        form.append('message', this.send.message)
        form.append('tipe', this.send.tipe)
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.post('/notif', form).then((result) => {
          if (result.data.message_id) {
            this.$toastr.s('Notifikasi berhasil dikirim')
            this.send.message = ''
          } else {
            var msg = 'Notifikasi gagal dikirim, silahkan coba kembali'
            if (result.data.message !== '') msg = result.data.message
            this.$toastr.e(msg)
          }
          this.isLoading = false
        }).catch(e => {
          var msg = 'Terjadi kesalahan pada server, mohon ulangi'
          if (e.response.data.message) msg = e.response.data.message
          this.$toastr.e(msg)
          this.isLoading = false
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/view/Notifikasi.vue